import { ref } from "vue";

// 总后台
export const admin = ref({
  adminToken: localStorage.getItem("adminToken") || "",
  adminUserInfo: JSON.parse(localStorage.getItem("adminUserInfo")) || "",
});
// 店铺后台
export const adminStore = ref({
  adminStoreToken: localStorage.getItem("adminStoreToken") || "",
  adminStoreInfo: localStorage.getItem("adminStoreInfo") || "",
  adminStoreUserInfo: localStorage.getItem("adminStoreUserInfo") || "",
  adminShowStoreId: localStorage.getItem("adminShowStoreId") || "",
});

export const storehouseId = ref(0);
